import React, {
    PropsWithChildren,
    useCallback,
    useMemo,
    useRef,
    useState,
} from 'react';

import { CellItem } from '../RecyclerGridView/types';
import CellSelectionContext from './Context';

const CellSelectionProvider: React.FC<PropsWithChildren<{}>> = ({
    children,
}) => {
    const selectedCellRef = useRef<CellItem>(undefined);
    const [selectedCell, _setSelectedCell] = useState<CellItem>();

    const setSelectedCell = useCallback((cell?: CellItem) => {
        selectedCellRef.current = cell;
        _setSelectedCell(cell);
    }, []);

    const contextValue = useMemo(
        () => ({
            selectedCell,
            setSelectedCell,
            selectedCellRef,
        }),
        [selectedCell, setSelectedCell],
    );

    return (
        <CellSelectionContext.Provider value={contextValue}>
            {children}
        </CellSelectionContext.Provider>
    );
};

export default CellSelectionProvider;
